// extracted by mini-css-extract-plugin
export default {"elementContainer":"ColumnSection_elementContainer__EjeWM","container":"ColumnSection_container__bd7sR"};